import { render, staticRenderFns } from "./BannedWordRemoved.vue?vue&type=template&id=278a9130&scoped=true"
import script from "./BannedWordRemoved.vue?vue&type=script&lang=js"
export * from "./BannedWordRemoved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278a9130",
  null
  
)

export default component.exports